export default __webpack_public_path__ + "static/media/promo-1.d14a1140.png";